export const canSplitSelection = (selectedItemsIds, lineItems) => {
  if (!lineItems?.length) return false

  return selectedItemsIds.length > 0 && selectedItemsIds.length < lineItems.length
}
